export default __webpack_public_path__ + "static/media/160-northern-marianas-islands.8b0b49ec.svg";